export default "__VITE_ASSET__DsXxcLzt__"